"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireDefault(require("react"));
var _system = require("@mui/system");
var _colors = _interopRequireDefault(require("../../theme/colors"));
/* eslint-disable arrow-body-style */

var CardBlockStyled = (0, _system.styled)('div')(function (_ref) {
  var theme = _ref.theme;
  return {
    '&:hover': {
      borderLeft: "5px solid ".concat(theme.palette.primary.main)
    },
    backgroundColor: _colors["default"].surface,
    borderLeft: "".concat(_colors["default"].surface, " solid 5px"),
    boxShadow: '0 1px 2px rgba(0, 0, 0, .15)',
    cursor: 'pointer',
    height: 'auto',
    marginBottom: '8px',
    minHeight: '90px',
    padding: '20px 30px 2px 25px',
    position: 'relative',
    zIndex: 4
  };
});
var CardBlock = /*#__PURE__*/_react["default"].forwardRef(function (props, ref) {
  var children = props.children,
    customStyle = props.customStyle;
  return /*#__PURE__*/_react["default"].createElement(CardBlockStyled, (0, _extends2["default"])({
    sx: customStyle,
    ref: ref
  }, props), children);
});
var _default = exports["default"] = CardBlock;